import { contentfulImageLoader } from "@utils/imageLoader";
import { FC } from "react";

import Image from "@/components/ui/Image/Image";
import getPositionClass from "@/utils/getPositionClass";

interface CardImageTextProps {
  src: string;
  altText: string;
  position: string;
  titleText: string;
  descriptionText?: string;
  textColor?: string;
  ratio: "3:4" | "4:3";
  gradient?: boolean;
  width?: number;
  height?: number;
}

const CardImageText: FC<CardImageTextProps> = ({ src, altText, position, titleText, descriptionText, textColor, ratio, gradient, width, height }) => {
  const is34 = ratio === "3:4";
  const widths = is34 ? [343, 473, 686, 946] : [457, 609, 840, 1218];
  return (
    <div className={`h-CardGallery md:h-CardGalleryDesktop ${is34 ? "aspect-3-4" : "aspect-4-3"} flex ${getPositionClass(position)}`}>
      <img
        className="absolute object-cover w-full h-full rounded-md"
        src={contentfulImageLoader({ src, width: widths[0], quality: 80 })}
        srcSet={widths.map((w) => `${contentfulImageLoader({ src, width: w, quality: 80 })} ${w}w`).join(", ")}
        sizes={is34 ? "(min-width: 1024px) 473px, 343px" : "(min-width: 1024px) 840px, 609px"}
        alt={altText}
        loading="lazy"
        decoding="async"
      />
      {gradient && <div className="img-overlay-5 absolute top-0 left-0 bottom-0 right-0"></div>}
      <div className={`w-full z-10 pb-xl pt-xl accent-color`} style={{ "--font-accent-color": textColor } as React.CSSProperties}>
        <p className="font-primary text-xl w-22\/24 mx-auto font-normal text-left pb-s uppercase accent-font accent-title">{titleText}</p>
        <p className="text-m w-22\/24 mx-auto font-medium  text-left">{descriptionText}</p>
      </div>
    </div>
  );
};
export default CardImageText;
